<template>
<div id="secure">

    <NewTopMenu />
    <div class="container">

        <div class="card is-hidden1">
            <div class="card-header">
                <p class="card-header-title"><nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
                <ul>
                    <li><a v-on:click="goManageForms()">Created Forms</a></li>
                    <li class="is-active"><a href="#" aria-current="page">Edit {{ name }}</a></li>
                </ul>
                </nav></p>
            </div>

        <!-- <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
                <li>
                    <a v-on:click="goManageForms()">Forms</a>
                </li>
                <li class="is-active">
                    <a href="#" aria-current="page">Edit {{ name }}</a>
                </li>
            </ul>
        </nav>
         -->

            <div class="card-content">
                <div class="content">
                    
                    <div class="columns">
                        <div class="column is-half">
                            <div class="field">
                                <label class="label">Form Name</label>
                                <div class="control">
                                    <input class="input" type="text" placeholder="e.g Visitor's Form" v-model="name">
                                </div>
                            </div>
                        </div>

                        <div class="column is-one-quarter">
                            <div class="field">
                                <label class="label">Number of fields (max 20)</label>
                                <div class="control">
                                    <input class="input" type="number" placeholder="1 - 20" v-model="fieldCount" @change="updateFieldCount()">
                                </div>
                            </div>
                        </div>

                        <div class="column is-one-quarter">
                            <div class="field">
                                <label class="label">Status</label>
                                <div class="control">
                                    <label class="radio">
                                        <input type="radio" :name="formStatus" v-model="formStatus" value="1" checked>
                                        Active
                                    </label>
                                    <label class="radio">
                                        <input type="radio" :name="formStatus" v-model="formStatus" value="0">
                                        Inactive
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="column is-full">
                        <div class="field" v-for="myFields in listOfMyFields" :key="myFields.id">
                            <div class="columns">
                                <div class="column is-one-third">
                                    <label class="label">Field name:</label>
                                    <div class="control"><input class="input" type="text" placeholder="" name="fieldName" v-model="myFields.fieldName"></div>
                                </div>
                                <div class="column">
                                    <label class="label">Field type:</label>
                                    <div class="control"><b-select name="fieldType" v-model="myFields.fieldType"><option selected value="1">Text field</option></b-select></div>
                                </div>
                                <div class="column">
                                    <label class="label">Required?</label>
                                    <div class="control"><b-select name="fieldRequired" v-model="myFields.fieldRequired"><option selected value="1">Yes</option><option selected value="2">No</option></b-select></div>
                                </div>
                                <div class="column is-one-third">
                                    <label class="label">Info to display:</label>
                                    <div class="control"><input class="input" type="text" placeholder="" name="fieldInfo" v-model="myFields.fieldInfo"></div>
                                </div>
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">&nbsp;</label>
                            <div class='ui two buttons'>
                                <button class='button is-primary' v-on:click="updateForm()">
                                    Update
                                </button>
                            </div>
                            <loading :active.sync="isLoading" 
                                :can-cancel="false" 
                                :is-full-page="true">
                            </loading>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
import NewTopMenu from "./../../NewTopMenu";
import AddContent from './AddContent';
import DataList from './DataList';
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "ManageFormsEdit",
    components: {
        NewTopMenu,
        Loading
    },
    data() {
        return {
            id: '',
            name: '',
            fieldCount: 0,
            currentFields: [],
            currentFieldCount: 0,
            formStatus: 1,
            result: "",
            errors: [],
            myFieldsLength: 0,
            listOfMyFields: [],
            myFields: {
                id: 0,
                fieldName: '',
                fieldType: 1,
                fieldRequired: 1
            },
            isLoading: false,
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    created() {
        this.id = this.$store.getters.getFormId;
        console.log("151 this.id: " + this.id)
        if (this.id.trim.length < 1){
            this.id = localStorage.getItem('FORM_ID')
        }

        this.name = this.$store.getters.getFormName;
        if (this.name.trim.length < 1){
            this.name = localStorage.getItem('FORM_NAME')
        }

        this.formStatus = this.$store.getters.getFormName;
        if (this.formStatus.trim.length < 1){
            this.formStatus = localStorage.getItem('FORM_STATUS')
        }
        console.log("146 formStatus: " + this.formStatus)

        this.currentFields = this.$store.getters.getFormFields;
        if (this.currentFields.length < 1){
            this.currentFields = localStorage.getItem('FORM_FIELDS')
        }
        
        console.log("93 currentFields:")
        console.log(this.currentFields[0])

        this.fieldCount = this.currentFields.length
        this.currentFieldCount = this.currentFields.length
        this.listOfMyFields = this.currentFields
    },
    mounted(){
    },
    methods: {
        updateFieldCount(){
            console.log("masuk updateFieldCount dengan: " + this.fieldCount)
            console.log("105 this.listOfMyFields: ")
            this.myFieldsLength = this.fieldCount   //strangely, line ni kena ada dekat sini dengan dekat atas (tapi dah hidden kan), kalau tak number of fields tak sync dgn dlm input

            // imin buat sini, find a way to retain the currently populated field values insyaAllah
            this.listOfMyFields = []

            for (var i = 0; i < this.fieldCount; i++){
                console.log("173 entering: " + i)
                var newObject = {
                    id: i,
                    name: 'field_' + i,
                    fieldType: 1,
                    fieldRequired: 1,
                    fieldInfo: ''
                }
                console.log("184 i sekarang brp: " + i)
                console.log("184 currentFields.length: " + this.currentFields.length)
                if (i >= this.currentFields.length){
                    //do nothing here
                }else{
                    newObject.id = i
                    newObject.fieldName = this.currentFields[i].fieldName
                    newObject.fieldType = this.currentFields[i].fieldType
                    newObject.fieldInfo = this.currentFields[i].fieldInfo
                    newObject.fieldRequired = this.currentFields[i].fieldRequired
                }
                this.listOfMyFields.push(newObject)
            }
            console.log("this.listOfMyFields.length: " + this.listOfMyFields.length)


        },
        updateForm() {
            let self = this;   

            var formId = this.id;
            var formName = this.name;
            var formStatus = this.formStatus;
            var fieldCount = this.fieldCount;

            if (formId.length < 2){
                Toast.open({
                    message: "Form Id NOT found. Please try to go back and click on the form edit button again.",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }

            if (formName.length < 2){
                alert("Please enter the form's name!")
                return false;
            }

            if (fieldCount < 1){
                alert("Please enter at least 1 field!")
                return false;
            }

            if (fieldCount > 20){
                alert("You can enter at most 20 fields!")
                return false;
            }

            for (var i = 0; i < this.listOfMyFields.length; i++){
                var fieldName = this.listOfMyFields[i].fieldName
                console.log("224 fieldName: " + fieldName)
                if ((fieldName == undefined) || (fieldName.length < 1)){
                    alert("Please enter the field " + (i + 1) + "'s name!")
                    return false;
                }
            }

            if ((formStatus == "0") || (formStatus == "1")){
                self.isLoading = true;

                axios.defaults.headers.common['Authorization'] = localStorage.getItem('newToken')
                axios.defaults.responseType = 'json'
                axios.post(process.env.NEW_ENDPOINT + '/form/update', {
                        loginEmail: localStorage.getItem('email'),
                        token: localStorage.getItem('newToken'),
                        schoolId: localStorage.getItem('schoolID'),
                        schoolNo: localStorage.getItem('schoolNo'),
                        country: localStorage.getItem('country'),
                        formId: formId,
                        formName: formName,
                        formStatus: formStatus,
                        formFields: this.listOfMyFields
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        // this.dataList = response.data
                        self.isLoading = false
                        if (response.data.success == false){
                            Toast.open({
                                message: 'Error: ' + response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        }else{
                            Toast.open({
                                message: 'Form successfully updated!',
                                type: 'is-success', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })                    
                        }
                    })
                    .catch(e => {
                        self.isLoading = false;
                        console.log("error")
                        console.log(e.response)
                        if (e.response.status === 401) {                            
                            Toast.open({
                                message: "Unauthorized access. Please re-login.",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })

                            console.log("salah login")
                            this.errors.push("Invalid login")
                        } else {
                            Toast.open({
                                message: 'Error: ' + e,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                            this.errors.push(e)
                        }
                    })                

            }else{
                alert("Please select the form's status!")
                return false;
            }
        },
        goManageForms() {
            this.$router.push({
                name: "ManageFormsHome"
            });
        },
    },
};
</script>

<style scoped>
.container{
    padding: 10px;
}
.box{
    border: 1px solid #ccc;
    width: 40% !important;
    margin: 4px;
    padding: 0px !important;
}
.active{
    border: 1px solid rgb(6, 50, 247);
}
</style>



// WEBPACK FOOTER //
// src/components/Manage/Forms/Edit.vue